import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { callApp, getSchemeLink } from '@ifeng-fe/callapp';
import { formatImageWebpAuto } from '@ifeng-fe/public_method';
import { WxLaunchApp } from 'ThreeTerminal_mobile_dynamic';
import { h5PageCount } from 'ThreeTerminal_utils';
import styles from './index.css';
import { getHotRankList } from '../../../../../services/api';

const downloadLink = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1497376949036';
const downloadAdLink = 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8852';
const kindStr = 'share52204';

class HotRank extends React.PureComponent {
    static propTypes = {
        base62Id: PropTypes.string,
    };

    state = {
        list: [],
    };

    componentDidMount() {
        this.getHotRankListData();
    }

    getHotRankListData = async () => {
        try {
            const res = await getHotRankList();
            const { code, data } = res;

            if (code === 0) {
                const getCallAppType = (type, url, weburl) => {
                    if (type === 'topic3') {
                        const topicid = url
                            .split('?')[1]
                            ?.split('&')
                            ?.map((item) => item.split('='))
                            ?.find((item) => item[0] === 'topicid')[1];

                        return { docType: type, pid: topicid };
                    } else if (type === 'hotspotlist') {
                        const eventName = url
                            .split('?')[1]
                            ?.split('&')
                            ?.map((item) => item.split('='))
                            ?.find((item) => item[0] === 'eventName')[1];
                        const nineDomain = typeof window === 'object' && window.allData?.__nd__ ? window.allData.__nd__ : 'ne883dbn.ifeng.com';

                        return {
                            docType: 'customPage',
                            pid: `https://${ nineDomain }/hotSpotDetailListV2?eventName=${eventName}&docid=&groupid=&type=customPage`,
                        };
                    } else {
                        return {
                            docType: navigator.userAgent.indexOf('Mac OS X') > -1 ? 'wkweb' : 'web',
                            pid: weburl,
                        };
                    }
                };

                const list = data.map((item) => {
                    let title = item?.hotLabel?.desp.replace(/#/g, '') || item?.hotLabel?.eventKeyword || item.title;
                    const describe = item?.title || '';
                    const describeType = item?.type || '';
                    const hotTrend = item.hotLabel?.hotTrend;
                    const isNew = item.hotLabel?.isNew;
                    const thumbnail = item?.thumbnail || item?.imageList?.[0]?.url || '';
                    const { docType, pid } = getCallAppType(
                        item.hotLabel?.link?.type,
                        item.hotLabel?.link?.url,
                        item.hotLabel?.link?.weburl,
                    );

                    title = item.hotLabel?.link?.type?.includes('topic') ? title : `#${title}`;

                    return { title, hotTrend, isNew, docType, pid, describe, thumbnail, describeType };
                });

                this.setState({ list });
            }
        } catch (e) {
            console.error(e);
        }
    };

    handleOpenAppClick = (isSendCount = true, isJumpQQlink = false, isCallApp = true) => {
        const { base62Id } = this.props;

        if (isSendCount) {
            h5PageCount([
                {
                    behavior: 'action',
                    type: 'hotlist',
                    other: {
                        ref: `ucms_${base62Id}`,
                    },
                },
            ]);
        }

        if (isJumpQQlink) {
            h5PageCount([
                {
                    behavior: 'action',
                    type: 'hotlist',
                    tag: 't9',
                    other: {
                        ref: `ucms_${base62Id}`,
                    },
                },
            ]);
        }
        if (isCallApp) {
            const nineDomain = typeof window === 'object' && window.allData?.__nd__ ? window.allData.__nd__ : 'ne883dbn.ifeng.com';

            callApp({
                docType: 'hotNewsRank',
                pid: `https://${ nineDomain }/hotnewsrank`,
                kind: kindStr,
                download: downloadLink,
                downloadAd: downloadAdLink,
            });
        }
    };

    handleItemClick = (docType, pid, isSendCount = true, isJumpQQlink = false, isCallApp = true) => {
        const { base62Id } = this.props;

        if (isSendCount) {
            h5PageCount([
                {
                    behavior: 'action',
                    type: 'hotlist',
                    other: {
                        ref: `ucms_${base62Id}`,
                    },
                },
            ]);
        }

        if (isJumpQQlink) {
            h5PageCount([
                {
                    behavior: 'action',
                    type: 'hotlist',
                    tag: 't9',
                    other: {
                        ref: `ucms_${base62Id}`,
                    },
                },
            ]);
        }
        if (isCallApp) {
            callApp({
                docType,
                pid,
                kind: kindStr,
                download: downloadLink,
                downloadAd: downloadAdLink,
            });
        }
    };

    render() {
        const { list } = this.state;
        const nineDomain = typeof window === 'object' && window.allData?.__nd__ ? window.allData.__nd__ : 'ne883dbn.ifeng.com';

        return (
            <div className={styles.wrap}>
                <div className={styles.header}>
                    <div className={styles.logo} />
                    <div
                        className={styles.more}
                        onClick={() => {
                            this.handleOpenAppClick();
                        }}>
                        <WxLaunchApp
                            launchType="app"
                            launchAppClick={() => {
                                this.handleOpenAppClick(true, false, false);
                            }}
                            schemeLink={getSchemeLink({
                                docType: 'hotNewsRank',
                                pid: `https://${ nineDomain }/hotnewsrank`,
                                kind: kindStr,
                            })}
                            launchAppFail={() => {
                                this.handleOpenAppClick(false, true, true);
                            }}
                        />
                        <div className={styles.moreText}>打开APP阅读</div>
                        <div className={styles.moreArrow} />
                    </div>
                </div>
                <div className={styles.list}>
                    {list.map((release, index) => {
                        const { title, docType, pid, hotTrend, isNew, describe, thumbnail, describeType } = release;

                        return (
                            <div
                                className={styles.release}
                                key={pid}
                                onClick={() => {
                                    this.handleItemClick(docType, pid);
                                }}>
                                <WxLaunchApp
                                    launchType="app"
                                    launchAppClick={() => {
                                        this.handleItemClick(docType, pid, true, false, false);
                                    }}
                                    schemeLink={getSchemeLink({
                                        docType,
                                        pid,
                                        kind: kindStr,
                                    })}
                                    launchAppFail={() => {
                                        this.handleItemClick(docType, pid, false, true, true);
                                    }}
                                />
                                <div className={styles.releaseBorder}>
                                    <div className={`${styles.rank} ${styles[`rank${index + 1}`]}`} />
                                    <div className={styles.textBox}>
                                        <div className={styles.title}>
                                            <div className={styles.titleText}>{title}</div>
                                            {isNew === '1' ? <div className={styles.titleNew} /> : null}
                                        </div>
                                        <div className={styles.bref}>{describe}</div>
                                    </div>
                                    {thumbnail && (
                                        <div className={styles.imageBox}>
                                            <img className={styles.pic} src={formatImageWebpAuto(thumbnail, 138, 92)} />
                                            {describeType === 'phvideo' && <div className={styles.playIcon} />}
                                        </div>
                                    )}
                                    <div
                                        className={`${styles.trends} ${hotTrend === '1' ? styles.trendsUp : ''} ${
                                            hotTrend === '0' ? styles.trendsDown : ''
                                        }`}
                                    />
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}

export default errorBoundary(HotRank);
